import { render, staticRenderFns } from "./HomeTestimonialSlider.vue?vue&type=template&id=53000d87&scoped=true&"
import script from "./HomeTestimonialSlider.vue?vue&type=script&lang=js&"
export * from "./HomeTestimonialSlider.vue?vue&type=script&lang=js&"
import style0 from "./HomeTestimonialSlider.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HomeTestimonialSlider.vue?vue&type=style&index=1&id=53000d87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53000d87",
  null
  
)

export default component.exports